import { createFileRoute, Outlet, useRouterState } from "@tanstack/react-router"
import { RoleGate } from "@/components/role-gate"
import { EmployerWorkspaceBoundary } from "@/features/company"

export const Route = createFileRoute("/recruit")({
  component: RecruitLayout,
})

function isRecruitIndex(pathname: string) {
  return pathname === "/recruit" || pathname === "/recruit/"
}

function isRecruitJoin(pathname: string) {
  return pathname === "/recruit/join" || pathname.startsWith("/recruit/join/")
}

/** Desk routes only — marketing index and /recruit/join are public siblings. */
function isRecruitDeskPath(pathname: string) {
  return (
    pathname.startsWith("/recruit") &&
    !isRecruitIndex(pathname) &&
    !isRecruitJoin(pathname)
  )
}

function RecruitLayout() {
  const pathname = useRouterState({ select: (s) => s.location.pathname })
  // Router can commit the new pathname a render before this layout actually
  // unmounts (e.g. /recruit → /recruit/join). Don't mount the desk gate for
  // public paths or the join form gets bounced to /login.
  if (isRecruitIndex(pathname)) {
    return <Outlet />
  }
  if (!isRecruitDeskPath(pathname)) {
    return null
  }

  return (
    <RoleGate
      role="employer"
      isDeskPath={isRecruitDeskPath}
      onWrongRole={(navigate) => void navigate({ to: "/candidate" })}
    >
      <EmployerWorkspaceBoundary>
        <Outlet />
      </EmployerWorkspaceBoundary>
    </RoleGate>
  )
}
